import styled from "styled-components"
import Moment from "react-moment"
import {
  ArticleContentWrapperStyles,
  TopWrapperStyles,
  RichTextWrapperStyles,
  ArrowBackNewsStyles,
  BackToNewsStyles,
  DateStyles,
} from "./article-content-styles"
import { colors } from "../../helpers/colors"
import { fonts } from "../../helpers/fonts"
import { Link } from "gatsby"
import { ContentStyles } from "../article-preview/article-preview-styles"


export const ArticleContentWrapper = styled.article`
  ${ArticleContentWrapperStyles}
`

export const BackToNews = styled.div`
  display: flex;
  color: ${colors.yellow};
  ${fonts.families.motiva};
  font-size: 17px;
  align-items: center;
  font-weight: 400;
  ${BackToNewsStyles};
`

export const Content = styled(Link)`
`

export const TopWrapper = styled.div`
  text-transform: uppercase;
  ${TopWrapperStyles}
`

export const ArrowBackNews = styled.div`
  ${ArrowBackNewsStyles}
`

export const RichTextWrapper = styled.div`
  a {
    color: ${colors.gray};
  }
  ${RichTextWrapperStyles}
`

export const Date = styled(Moment)`
  ${DateStyles}
`
